import type { FieldError } from 'react-hook-form';

export interface FormMessageProps {
  id: string;
  error: FieldError | undefined;
  helperText?: string;
}

export function FormMessage({ id, error, helperText }: FormMessageProps) {
  const text = error?.message ?? helperText;
  if (!text) {
    return null;
  }

  return (
    <p id={`${id}-${error ? 'error' : 'helper'}`} className={`text-sm ${error ? 'text-error-on-subtle' : 'text-muted-foreground'}`}>
      {text}
    </p>
  );
}
